module.exports = __webpack_public_path__ + "static/media/22.f62d7376.png";